
<style scoped>
.window-container {
	max-width: 80%;
	text-align: center;
	margin: 0 auto;

}
.quick-query {
  border-radius: 25px;
  border: 2px solid #000000;
  padding: 20px; 

}

.query-input-title {
	text-align:left;
}
.query-form-title {
	background-color: #eeeeee;
	text-align: center;
	padding-top: 5px;
	padding-right: 5px;
	padding-bottom: 5px;
	padding-left: 10px;
	font-weight: bold;
	
}
.example-input {
	cursor:pointer;
	color: blue;
}
.submit-button {
	cursor:pointer;
	color: red;
	border-radius: 15px;
	border: 1px solid #FF0000;
	padding: 15px; 
	
}
.overflow-dropdown-menu /deep/ .dropdown-menu  {
	max-height: 300px;
	overflow-y: auto;
}
.imgSet {
    width: 50%;
    //height: 100%;
    object-fit: contain;
}
.header-row-bg-div {
	margin-top:20px;
	margin-bottom:20px;
	/*background-color: #ee11ee;*/

}
.header-row-text-div {
	margin-left: 5%;
	margin-right: 5%;
	margin-top:50px;
	margin-bottom:50px;
	
}
.header-text {
	object-fit: contain;
}
.header-description {
	margin-top:50px;
	text-align: left;
	font-family:"Myriad-Pro"
}
.query-card {
	border: #f3f8e9 solid 5px;
	border-radius:10px;
}
.query-card-title {
	background-color: #f3f8e9;
	border-radius:10px;
	margin-top:0px;
	margin-bottom:0px;
	font-weight: bold;
	padding-top: 25px;
	padding-bottom: 25px;
	font-size: large;
}
.input-text-area {
	border: #add26b solid 2px;
	width:90%;
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;
}
.search-button {
	background-color:#add26b;
	color:white;
	border: #add26b solid 2px;
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px;
}
.input-form {
	width:100%;
}
.example-row {
	align:center;
	margin:auto
}
@import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css';

</style>
<!-- <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">-->

<template>
	
	<div class="window-container">
		<div class="header-row-bg-div" >
			<div class ="header-row-text-div">		
				<div class="header-text">
					<img class="imgSet" src="@/assets/images/Query4.png" />
				</div>
			</div>

		</div>
		<!--
			<p>Hotspot 3Dneighborhood is a computational tool for….</p>
			
			<p> To get started, search for your protein or gene: </p>
		-->

		<div class="query-card">
			<div class="query-card-title"> Search by protein or gene ID</div>
			
			<div class="submission-input">
			<!--
			<b-row class="mb-2">
				<b-col cols="4">
					<div class="query-input-title"> Type of hotspot 3Dneighborhood: </div>
				</b-col>
				<b-col cols="8">
					<b-dropdown :text=methodType class="overflow-dropdown-menu" block menu-class="w-100">
							<b-dropdown-item @click="methodType = mt" v-for="mt in availableMethodTypes" :key="mt"> 
								{{ mt }}
							</b-dropdown-item>
						
					</b-dropdown>
				</b-col>
			</b-row>
			-->
			<img src="QueryDatabase.png" width="50%" class="imgSet"/>
			<b-col>
				<b-row class="search-row">
					<form class="input-form">
						<input class="input-text-area" type="text" v-model="userProteinQuery" placeholder="UniProt ID, Ensembl protein ID, and gene name are accepted..">
						<button class="search-button" type="submit" @click="sendQuery()"><i class="fa fa-search"></i></button>
					</form>
				</b-row>
				<b-row>
					<div class="example-row">
						<label class="example-input" @click="userProteinQuery = 'KRAS'">
							<i> Example 1 (Protein name) </i>
						</label>
						|
						<label class="example-input" @click="userProteinQuery = 'P01116'">
							<i> Example 2 (UniProt ID) </i>
						</label>
						|
						<label class="example-input" @click="userProteinQuery = 'ENSP00000256078'">
							<i> Example 3 (ENSP ID) </i>
						</label>
					</div>
				</b-row>					
			</b-col>
			<!--
			<b-row class="mb-2">
				<b-col cols="4">
					<div class="query-input-title"> Cancer type: </div>
				</b-col>
				<b-col cols="8">
					<b-dropdown :text=cancerType class="overflow-dropdown-menu" block menu-class="w-100">
						<b-dropdown-item @click="cancerType = mt" class="overflow-dropdown-menu" v-for="mt in availableCancerTypes"	:key="mt" > 
							{{ mt }}
						</b-dropdown-item>
					</b-dropdown>			
				</b-col>
			</b-row>
			-->
			<!--
			<b-row class="mb-2">
				<b-col cols="4">
					<div class="query-input-title"> P-value cut-off: </div>
				</b-col>
				<b-col cols="8">
					<b-form-textarea rows="1" v-model="userPvalueCutoff" placeholder="Input p-value cut-off"></b-form-textarea>
				</b-col>
			</b-row>			
			<b-row class="mb-2">
				<b-col cols="4">
					<div class="query-input-title"> P-value correction: (Not functional)</div>
				</b-col>
				<b-col cols="8">
					<b-form-radio-group v-model="userPvalueCorrectionOptions" >
						<b-row>
						<div v-for="o in pvalueCorrectionOptions" :key="o">
							<b-form-radio :value="o">{{o}}</b-form-radio>
						</div>
						</b-row>
					</b-form-radio-group>
				</b-col>
			</b-row>			
			-->
			</div>
			<!--<label class="submit-button" @click="sendQuery()">Submit</label>			-->
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "advanced",

	data() {
		return {
			availableMethodTypes: ["Inter-protein", "Intra-protein"],
			availableCancerTypes: [],
			methodType: "Inter-protein",
			userProteinQuery: "",
			cancerType: "",
			userPvalueCutoff: "0.05",
			userPvalueCorrectionOptions: "Bonferroni",
			showError: false,
			errorMessage: "Please enter a protein name",
			optionsRadio: [
				{ text: "Inter-molecular", value: "Inter" },
				{ text: "Intra-molecular", value: "Intra" }
			],
			selectedCheckbox: [],
			optionsCheckbox: [
				{ text: "Option 1", value: "O1" },
				{ text: "Option 2", value: "O2" },
				{ text: "Option 3", value: "O3" },
				{ text: "Option 4", value: "O4" }
			],
			pvalueCorrectionOptions: [
				"Bonferroni", "FDR", "No Correction"
			],
			queryProteinForm: {
				type: "",
				name: ""
			},
			// backend return value
			clusters: [],
			pdbs: [],
			uniprotData: Object,
			clusterData: Object,
			PDBClusterMapProp: Object,
			ClusterPDBMapProp: Object,
			developing: false,
		};
	},
	computed: {

	},
	created() {
		// Update method types
		this.methodType = this.availableMethodTypes[0];
		// Update cancer types
		const path = "http://netflow3dapi.yulab.org/cancertypes"; // Request cancer types
		axios.get(path).then(res => {
			this.availableCancerTypes = res.data.availableCancerTypes;
			this.cancerType = this.availableCancerTypes[0];
		});
		
	},
	methods: {
		sendQuery() {
			this.$router.push({
				name: "database",
				params: { 
					//"methodType": this.methodType,
					//"userProteinQuery": this.userProteinQuery,
					//"userPvalueCutoff": this.userPvalueCutoff
					"queryterm":this.userProteinQuery
				}
			});
		},
	}
};
</script>
